module.exports = __webpack_public_path__ + "img/base.0a4b844c.png";